import { NgModule } from '@angular/core'
import { translationChunksConfig, translations } from '@spartacus/assets'
import { FeaturesConfig, I18nConfig, provideConfig, SiteContextConfig } from '@spartacus/core'
import { defaultCmsContentProviders, layoutConfig, mediaConfig } from '@spartacus/storefront'

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    provideConfig(layoutConfig),
    provideConfig(mediaConfig),
    ...defaultCmsContentProviders,
    provideConfig(
      {
        context: {
          currency: ['USD'],
          language: ['en'],
        },
      } as SiteContextConfig
    ),
    provideConfig({
        i18n: {
          resources: translations,
          chunks: translationChunksConfig,
          fallbackLang: 'en'
        },
      } as I18nConfig
    ),
    provideConfig(
      {
        features: {
          level: '6.0.1'
        }
      } as FeaturesConfig
    )
  ]
})
export class SpartacusConfigurationModule {
}
